import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/data/site";
import { useLang, u } from "@/data/i18n";

export default function WhatsAppFloat() {
  const { lang } = useLang();
  return (
    <motion.a
      data-testid="whatsapp-float-btn"
      href={buildWhatsAppLink("Hello Lovely Foodpacks! I'd like to enquire about your products.")}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      initial={{ opacity: 0, scale: 0.6 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay: 2, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2.5 bg-leaf-bright text-white pl-4 pr-5 py-3.5 shadow-2xl font-bold text-sm tracking-wide"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline">{u(lang, "float_chat")}</span>
    </motion.a>
  );
}
